import  React from "react";
import { BrowserRouter,Route,Switch } from 'react-router-dom';  
import firebase from "firebase";
import MaterialTable from "material-table";
import DialogProveedor from "views/Proveedor/DialogProveedor.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";

class Proveedor extends React.Component {

  constructor(props) {
      super(props);

      this.state = {
        data: [] ,
        modalIsOpen: false,
        isEdited: false,
        rowData: {},
        isDeleted: false ,
        listadoEmpresas : []
      };

       const db = firebase.firestore();
        db.collection('APIProveedores')
        .onSnapshot((snapshot) => {
          const _data = snapshot.docs.map(doc => doc.data());
          this.setState({ columns: [
                            { title: 'Codigo', field: 'codigo' },
                            { title: 'Nombre', field: 'nombre'  },
                            { title: 'Responsable', field: 'responsable'  },
                            { title: 'Email', field: 'email'  } 
                          ],
                          data: _data,
                          actions : [
                            {
                              icon: 'search',
                              tooltip: 'Detalle Proveedor',
                              onClick: (event,rowdata) => this.setState({modalIsOpen: true,isEdited: false,rowData:rowdata,isDeleted:false})
                            },
                            {
                              icon: 'add_box',
                              tooltip: 'Agregar Proveedor',
                              isFreeAction: true,
                              onClick: (event) =>  this.setState({modalIsOpen: true,isEdited: true,rowData:null,isDeleted:false,isDeleted:false})
                            },{
                              icon: 'edit',
                              tooltip: 'Editar Proveedor',
                              onClick: (event,rowdata) =>  this.setState({modalIsOpen: true,isEdited: true,rowData:rowdata,isDeleted:false})  
                            },{
                              icon: 'delete_outline',
                              tooltip: 'Eliminar Proveedor',
                              onClick: (event,rowdata) =>   this.setState({modalIsOpen: true,isEdited: false,rowData:rowdata,isDeleted:true})
                            },
                            {
                              icon: 'sync',
                              tooltip: 'Integrar Proveedor',
                              onClick: (event,rowdata) =>   this.props.history.push({
                                pathname : '/admin/integrarproveedor',
                                state :{
                                codigo_proveedor : rowdata.codigo,
                                nombre_proveedor : rowdata.nombre 
                                }
                                } 
                              ) 
                            }
                          ]
          });
        }, (error) => {
          console.log(error);
        });


        db.collection('APIEmpresas')
        .onSnapshot((snapshot) => {
          const _data1 = snapshot.docs.map(doc => doc.data());
             this.setState({listadoEmpresas : _data1});
            }, (error) => {
              console.log(error);
            });

        
        this.openModal = this.openModal.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);

        
        const storedUsuario = localStorage.getItem("usuario");
        if (storedUsuario === null) {
            window.location.href = '/admin/dashboard'; 
        }
    }

    openModal() {
      this.setState({modalIsOpen: true});
    }
   
    afterOpenModal() {
      // references are now sync'd and can be accessed.
      this.subtitle.style.color = '#f00';
    }
   
    closeModal() {
      this.setState({modalIsOpen: false});
    }   

render(){
 
  const customStyles = {
    content : {
      top                   : '50%',
      left                  : '50%',
      right                 : 'auto',
      bottom                : 'auto',
      marginRight           : '-50%',
      transform             : 'translate(-50%, -50%)'
    }
  };

return (
            <div>
              <MaterialTable
                  title="Listado de Proveedores"
                  columns={this.state.columns}
                  data={this.state.data}
                  actions={this.state.actions}
                  options={{
                    exportButton: true
                  }}
                />
                <DialogProveedor modalIsOpen={this.state.modalIsOpen}  closeModal={this.closeModal}  isEdited={this.state.isEdited}  rowData={this.state.rowData} isDeleted={this.state.isDeleted}  listadoEmpresas={this.state.listadoEmpresas}  />
              
            </div>
        );        
    }
}

export default Proveedor;